import { configureStore } from '@reduxjs/toolkit'
import { MahutiReducer } from './MahutiReducer'



// {"reducer":{"visitors":{"adults":0,"underAge":0},"selectedActivity":{},"activityDate":"2023-02-27T14:59:20.832Z"},"getInitialState":{"visitors":{"adults":0,"underAge":0},"selectedActivity":{},"activityDate":"2023-02-27T14:59:20.832Z"}}


export default configureStore({
  reducer: MahutiReducer,
})